import React from "react";
import { Breadcrumbs, Text } from "@mantine/core";
import { useLocation, Link } from "react-router-dom";
import { useNavigate } from "react-router";

const CustomBreadcrumbs = () => {
  const { pathname } = useLocation();
  const navigate = useNavigate();

  const pathSegments = pathname
    .split("/")
    .filter((segment) => segment)
    .slice(-2);

  const handleSegmentClick = (index: number) => {
    navigate(-1);
  };

  const lastSegment = pathSegments[pathSegments.length - 1];
  const secondLastSegment = pathSegments[pathSegments.length - 2];
  const shouldDisplayCreateNewApplication =
    lastSegment === "ehr" || lastSegment === "wear";

  const breadcrumbs = pathSegments.map((segment, index) => {
    const displaySegment = segment
      .replace(/^\w/, (c) => c.toUpperCase())
      .replace(/_/g, " ");

    if (
      index === pathSegments.length - 1 &&
      shouldDisplayCreateNewApplication
    ) {
      return (
        <Text
          component={Link}
          to={"/" + segment}
          onClick={() => handleSegmentClick(index)}
          style={{ textDecoration: "none" }}
          size="lg"
          color={index === pathSegments.length - 1 ? "#262930" : "#999999"}
          key={index}
        >
          Create New Application
        </Text>
      );
    } else if (
      index === pathSegments.length - 2 &&
      shouldDisplayCreateNewApplication
    ) {
      return (
        <Text
          component={Link}
          to={"/" + secondLastSegment + "/" + lastSegment}
          onClick={() => handleSegmentClick(index)}
          style={{ textDecoration: "none" }}
          size="lg"
          color={index === pathSegments.length - 1 ? "#262930" : "#999999"}
          key={index}
        >
          {displaySegment}
        </Text>
      );
    } else {
      return (
        <Text
          component={Link}
          to={"/" + segment}
          onClick={() => handleSegmentClick(index)}
          style={{ textDecoration: "none" }}
          size="lg"
          color={index === pathSegments.length - 1 ? "#262930" : "#999999"}
          key={index}
        >
          {displaySegment}
        </Text>
      );
    }
  });
  

  return (
    <div>
      <Breadcrumbs>{breadcrumbs}</Breadcrumbs>
    </div>
  );
};

export default CustomBreadcrumbs;
